import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { Range } from '@osd/ui/range';
import { Stack } from '@osd/ui/stack';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/range — live docs for the `Range` primitive.
 *
 * `Range` is a continuous numeric slider. Optional `label`,
 * `hint`, and `showValue` (rendered live as the user drags).
 * Forwarded ref so consumers can imperatively focus or read the
 * current value via the underlying `<input type="range">`.
 */
export const Route = createFileRoute('/ui/_layout/range')({
  component: RangePage,
});

function RangePage() {
  const [volume, setVolume] = useState(50);
  const [alpha, setAlpha] = useState(0.8);

  return (
    <Stack gap={6}>
      <Section title="Range" hint="Continuous numeric slider with optional label + live value">
        <Stack gap={4}>
          <Range
            label="Volume"
            showValue
            value={volume}
            min={0}
            max={100}
            onChange={(e) => setVolume(Number(e.target.value))}
          />
          <Range
            label="Opacity"
            showValue
            value={alpha}
            min={0}
            max={1}
            step={0.05}
            onChange={(e) => setAlpha(Number(e.target.value))}
            hint="Applied to the swatch underneath."
          />
          <Range label="Without value display" defaultValue={25} />
          <Range label="Disabled" defaultValue={30} disabled />
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            language="tsx"
            title="Controlled with live value display"
            code={`const [volume, setVolume] = useState(50);

<Range
  label="Volume"
  showValue
  value={volume}
  min={0}
  max={100}
  onChange={(e) => setVolume(Number(e.target.value))}
/>
`}
          />

          <CodeBlock
            language="tsx"
            title="Uncontrolled, with hint"
            code={`<Range
  label="Brightness"
  defaultValue={50}
  hint="Auto-saves on release."
/>
`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
